import { SearchResultType } from '@ecs-services/search/search.interface';
import { ResponseError } from '@ecs-types/error.type';
import { PartsRecommendation } from 'src/app/components/parts-recommendation/parts-recommendation.interface';

export enum SparePartStatus {
    HIGH = 'HIGH',
    LOW = 'LOW',
    NONE = 'NONE',
}

export interface SparePartAvailability {
    code: string;
    text: string;
    status: SparePartStatus;
    tooltip: string;
}

export interface SparePart {
    id: string;
    name: string;
    nameExternal?: string;
    favorite: boolean;
    plantId: string;
    availabilityCode: string;
    /**
     * Text to display in table, if availabilityCode !== 00, 03, 04
     */
    availabilityText?: string;
    availability?: SparePartAvailability;

    /**
     * sparePart-ID (Sachnummer)
     *
     *  @example 41041
     */
    itemNumber?: string;
    wear?: boolean;
    installedQuantity?: number;
    recommendation?: PartsRecommendation;
    isPartOf?: number[];
    crossSelling?: CrossSelling;
    gearOilQuantity?: number;
    unit?: string;
    /**
     * Used in Accessories-Request
     */
    descriptionHtml?: string;
}

interface CrossSelling {
    gearOil?: { specificationId: string };
    cable?: boolean;
    eCover?: boolean;
    eCoverDialog?: boolean;
}

export interface SparePartGroup {
    title: string;
    iconName?: string;
    driveGroup?: string;
    driveGroupNumber?: number;
    driveGroupProductName?: string;
    disableAddGroupToCart?: boolean;
    disableAddGroupToCartText?: string;
    spareParts?: SpareParts;
}

export type SpareParts = SparePart[];
export type SparePartGroups = SparePartGroup[];

// TODO: do we need this interface?
export interface SparePartsCollection {
    spareParts: SpareParts;
    errors?: string[];
}

// TODO: do we need this interface?
export interface SparePartGroupList {
    groups: SparePartGroups;
    type?: SearchResultType;
}

export interface SparePartsResponseError {
    status: number;
    statusText: string;
    error: ResponseError;
}
